//import { createStore } from 'redux'
import { createStore, applyMiddleware } from 'redux'
import appReducer from './reducers';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { userConstant } from './constants';


const logEnabled = process.env.REACT_APP_LOGGER_ENABLED;
const loggerMiddleware =  createLogger();

const initialState = {
  sidebarShow: 'responsive'
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return {...state, ...rest }
    default:
      return state
  }
}

//const store = createStore(changeState)

const rootReducer = (state, action) => {
  if (action.type === userConstant.LOGOUT) {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

const store = createStore(
  rootReducer,
  logEnabled=="true"? applyMiddleware(thunkMiddleware,loggerMiddleware) : applyMiddleware(thunkMiddleware) 
  
);

export default store